import { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { AppScope } from '../appScope.types';
import { StashedAppScope } from './StashedAppScope';

/**
 * The booking sidebar's opener scope. A Redux key of its own
 * (`bookingSidebarAppScope`), so conflict modals do not overwrite it.
 */
export function PortaledBookingSidebarAppScope({
  children
}: {
  children: ReactNode;
}) {
  const stashed = useSelector(
    (state: { ui: { bookingSidebarAppScope: AppScope | null } }) =>
      state.ui.bookingSidebarAppScope
  );
  return <StashedAppScope stashed={stashed}>{children}</StashedAppScope>;
}
